import Vue from 'vue'
import {
  Form,
  FormItem,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Message,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  MenuItem,
  Card,
  Alert,
  Upload,
  Pagination,
  Row,
  Col,
  Table,
  TableColumn,
  Tooltip,
  MessageBox,
  Dialog,
  Tree,
  Select,
  Option,
  Badge,
  Switch,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane
} from 'element-ui'

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Card)
Vue.use(Alert)
Vue.use(Upload)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(Badge)
Vue.use(Switch)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
